<template>
<!-- 线上基础班查询编辑 -->
    <div  class="base-class-box">
        <el-form  :model="form" label-width="80px">
            <el-form-item class="select" label="班级名称" :label-width="formLabelWidth">
                <el-select v-model="form.class_name" placeholder="请选择班级名称">
                    <el-option v-for="(item,index) in class_name_List" :key="index" :label="item" :value="item">{{item}}</el-option>
                </el-select>
            </el-form-item>
            <!--  -->
            <el-form-item class="select"  label="组号" :label-width="formLabelWidth">
                <el-select v-model="form.group_no" placeholder="请选择组号">
                    <el-option v-for="(item,index) in group_no_List" :key="index" :label="item" :value="item">{{item}}</el-option>
                </el-select>
            </el-form-item>
            <!--  -->
            <el-form-item label="促动师" :label-width="formLabelWidth">
                <el-input v-model="form.lf" autocomplete="off" placeholder="请输入促动师"></el-input>
            </el-form-item>
            <!-- 促动师上传图片 -->
            <el-form-item  label="促动师二维码" :label-width="formLabelWidth">
                <el-upload
                    class="upload-demo"
                    :show-file-list="false"
                    :http-request="uploadImg"
                    :before-upload="beforeAvatarUpload">
                    <el-button @click="up_type='lf_qrcode'" size="small" type="primary">点击上传</el-button>
                </el-upload>
                <!--  -->
                <el-image v-if="form.lf_qrcode" class="up-image" :src="form.lf_qrcode">
                    <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                    </div>
                    <div slot="error" :style="{height:'150px','line-height':'150px'}" class="image-slot error">
                        请上传图片...
                    </div>
                </el-image>
            </el-form-item>
            <!--  -->
            <el-form-item label="姓名" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <!--  -->
            <el-form-item class="select"  label="性别" :label-width="formLabelWidth">
                <el-select v-model="form.gender" placeholder="请选择性别">
                    <el-option  label="男" value="男">男</el-option>
                    <el-option  label="女" value="女">女</el-option>
                </el-select>
            </el-form-item>
            <!--  -->
            <el-form-item label="手机号" :label-width="formLabelWidth">
                <el-input v-model="form.phone" autocomplete="off" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <!--  -->
            <el-form-item label="邮箱" :label-width="formLabelWidth">
                <el-input v-model="form.email" autocomplete="off" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <!--  -->
            <el-form-item label="行业" :label-width="formLabelWidth">
                <el-input v-model="form.industry" autocomplete="off" placeholder="请输入行业"></el-input>
            </el-form-item>
            <!--  -->
            <el-form-item label="职业" :label-width="formLabelWidth">
                <el-input v-model="form.job" autocomplete="off" placeholder="请输入职业"></el-input>
            </el-form-item>
            <!--  -->
            <el-form-item label="省份" :label-width="formLabelWidth">
                <el-input v-model="form.province" autocomplete="off" placeholder="请输入省份"></el-input>
            </el-form-item>
            <!--  -->
            <el-form-item label="顾问" :label-width="formLabelWidth">
                <el-input v-model="form.saler" autocomplete="off" placeholder="请输入顾问"></el-input>
            </el-form-item>
            <!-- 上传图片 -->
            <el-form-item  label="课程表" :label-width="formLabelWidth">
                <el-upload
                    class="upload-demo"
                    :show-file-list="false"
                    :http-request="uploadImg"
                    :before-upload="beforeAvatarUpload">
                    <el-button @click="up_type='curriculum'"  size="small" type="primary">点击上传</el-button>
                </el-upload>
                <!--  -->
                <el-image v-if="form.curriculum" class="up-image" :src="form.curriculum">
                    <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                    </div>
                    <div slot="error" :style="{height:'150px','line-height':'150px'}" class="image-slot error">
                        请上传图片...
                    </div>
                </el-image>
            </el-form-item>
            <!--  -->
            <el-form-item :label-width="formLabelWidth">
                <el-button type="primary" @click="vailBasis">保存</el-button>
                <el-button @click="$router.go(-1)">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { getUserinfo,upload_image,addUserinfo,updateUserinfo,getClassname,getGroupno } from "@/api/course";

export default {
    data() {
        return{
            formLabelWidth: '130px',
            class_name_list:[],
            group_no_List:[],
            form:{},
            up_type:''
        }
    },
    methods:{
        // 获取基础信息
        findBasisHandle(){
            this.$showLoading();
            getUserinfo({
                id:this.$route.query.id
            }).then((data)=>{
                this.$hideLoading();
                this.form = data.item;
            });
        },
        getListData(){
            // 获取班级列表
            getClassname().then((data)=>{
            if(data.error>0){
                this.$message(data.msg);
                return
            }
            
            this.pullData(data.list);
            });

        },
        pullData(arr){
            if(arr && arr.length>0){
                this.class_name_List = arr;
            }
            
            // 获取组号列表
            getGroupno({
                class_name:this.class_name?this.class_name:this.class_name_List[0]
            }).then((data)=>{
                if(data.error>0){
                this.$message(data.msg);
                return
                }
                this.group_no_List = data.list;
            });
            if(this.$route.query.id){
                this.findBasisHandle();
            }
          
        },
        // 验证
        vailBasis(){
            if(this.form.id){
                updateUserinfo(this.form).then((data)=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return
                    }
                    this.$notify({
                        title: '成功',
                        message: '编辑成功',
                        type: 'success'
                    });
                        
                    this.$router.go(-1);
                });
            }else{
                addUserinfo(this.form).then((data)=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return
                    }
                    this.$notify({
                        title: '成功',
                        message: '添加成功',
                        type: 'success'
                    });
                        
                    this.$router.go(-1);
                });
            }
            
           
        },
        beforeAvatarUpload(file) {
            const isJPG = true;
            const isLt2M = file.size / 1024/ 1024  < 1;

            if (!file.type === 'image/jpg' || !file.type === 'image/png' || !file.type === 'image/gif' ) {
                isJPG = false;
                this.$message.error('上传头像图片只能是 jpg/png/gif 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 1MB!');
            }
            return isJPG && isLt2M;
        },
        uploadImg(param){
            // FormData 对象
            let form = new FormData();
            // 文件对象
            form.append("image", param.file);
            // 携带当前讲座的id
            form.append("key", this.$route.path);
            form.append("preserve", 1);

            // 上传图片接口
            upload_image(form).then((data)=>{
                this.$forceUpdate();
                this.form[this.up_type] = data.image_url;
            });
        }
    },
    created(){
        this.getListData();
    }
}
</script>

<style lang="scss" scoped>
.base-class-box{
    background-color: #fff;
    padding: 50px 0;
    border-radius: 8px;
    .el-input,.el-textarea{
        width:775px;
    }
    .grouping{
        width:100%;
        .grouping-left,.grouping-right{
            width: 50%;
            display: inline-block;
        }
        .grouping-right .el-input{
            width: 250px;
        }
    }
    .select,.el-select{
        width:500px;
    }
}
.up-image{
    margin: 20px auto auto;
    width: 187.5px;
    text-align: center;
    border-radius: 8px;
    .error{
        border-radius: 8px;
        background-color: rgba($color: #eeeeee, $alpha: .5);
    }
}
</style>
